export type FinaleWeaponId = 'plasma-rifle' | 'flamethrower' | 'bazooka' | 'grenade-launcher' | 'sniper-rifle' | 'mag7';

export interface FinaleWeapon {
  id: FinaleWeaponId;
  name: string;
  shortName: string;
  score: number;
  damage: number;
  cooldownMs: number;
  accent: string;
  recoil: string;
}

export const finaleWeapons: FinaleWeapon[] = [
  { id: 'plasma-rifle', name: 'Violet Plasma Rifle', shortName: 'PLASMA', score: 100, damage: 70, cooldownMs: 520, accent: '#c77dff', recoil: 'light' },
  { id: 'flamethrower', name: 'Smacker Furnace', shortName: 'FLAME', score: 125, damage: 48, cooldownMs: 360, accent: '#ff8a3d', recoil: 'medium' },
  { id: 'bazooka', name: 'Island Breaker', shortName: 'BAZOOKA', score: 250, damage: 165, cooldownMs: 880, accent: '#f3cf4f', recoil: 'heavy' },
  { id: 'grenade-launcher', name: 'Arc Grenadier', shortName: 'GRENADES', score: 175, damage: 120, cooldownMs: 680, accent: '#65e6ff', recoil: 'heavy' },
  { id: 'sniper-rifle', name: 'Long Purple', shortName: 'SNIPER', score: 300, damage: 210, cooldownMs: 760, accent: '#8fffea', recoil: 'medium' },
  { id: 'mag7', name: 'Neon MAG-7', shortName: 'MAG-7', score: 150, damage: 95, cooldownMs: 430, accent: '#ea72ff', recoil: 'heavy' },
];

export const finaleScoreKey = 'smackers-finale-scores-v2';
export const finalePlayerKey = 'smackers-finale-player-v1';
export const finaleSeedScores: FinaleScoreEntry[] = [
  { name: 'AL B BACK', score: 60000, elapsedMs: 101000, cleared: 8, godMode: false, recordedAt: '1994-01-05T00:00:00.000Z' },
  { name: 'HUGH JASS', score: 50000, elapsedMs: 108000, cleared: 7, godMode: false, recordedAt: '1994-01-04T00:00:00.000Z' },
  { name: 'ANITA BATH', score: 40000, elapsedMs: 115000, cleared: 6, godMode: false, recordedAt: '1994-01-03T00:00:00.000Z' },
  { name: 'BEN DOVER', score: 30000, elapsedMs: 122000, cleared: 5, godMode: false, recordedAt: '1994-01-02T00:00:00.000Z' },
  { name: 'IPFREELY', score: 20000, elapsedMs: 130000, cleared: 4, godMode: false, recordedAt: '1994-01-01T00:00:00.000Z' },
];
export const finaleLevelCount = 20;
export const finaleBossHealth = 9000;
export const finalePowerMax = 20;
export const finaleReloadEvery = 50;

export const destructionMultiplier = (level: number) => 2 ** Math.max(0, level - 1);
export const levelTargetCount = (level: number) => Math.min(20, 9 + Math.floor(level / 2));
export const copyHitsRequired = (level: number) => Math.min(8, 1 + Math.floor((level - 1) / 3));
export const levelSpeed = (level: number) => Math.min(7.5, 0.7 * Math.pow(1.16, Math.max(0, level - 3)));
export const enemyFireDelay = (level: number) => Math.max(280, 1800 - (level - 6) * 105);
export const enemyDamage = (level: number) => Math.min(22, 5 + Math.floor((level - 6) * 0.9));
export const effectDensity = (level: number) => Math.min(72, 14 + (level - 1) * 3);
export const poweredDamage = (damage: number, powerLevel: number) => Math.round(damage * (1 + (powerLevel - 1) * 0.34));
export const poweredCooldown = (cooldownMs: number, powerLevel: number) => Math.max(85, cooldownMs - (powerLevel - 1) * 24);

export interface FinaleScoreEntry {
  id?: number;
  name: string;
  score: number;
  elapsedMs: number;
  cleared: number;
  bossDefeated?: boolean;
  powerLevel?: number;
  godMode: boolean;
  recordedAt: string;
}
